<template>
  <div class="h-100 d-flex flex-column">
    <div
      class="row f-row justify-content-center"
      style="vertical-align: middle!important;"
    >
      <div
        class="col col-12 text-center progress-div"
        v-if="showLoading"
        style="top: calc(50vh - 57px);"
      >
        <QSLoading
          :isLoading="showLoadingSpot"
          :size="20"
          :colorTheme="colorTheme"
        />
      </div>
      <div
        class="col col-12 text-center no_nav_titles_height"
        style="overflow: auto; margin: 10px 0 10px 0!important;"
      >
        <table
          class="table table-sm table-borderless fep_cess_comp_table fepCessionComp"
          style="width: 100%!important;"
        >
          <tbody class="text-center align-center">
            <tr>
              <th
                colspan="3"
                v-bind:class="{
                  'row-hover': hRow === 1,
                }"
                @mouseover="onHoverRow(1)"
                @mouseleave="onHoverRow(-1)"
              >
                Month
              </th>
              <td
                colspan="6"
                v-bind:class="{
                  'row-hover': hRow === 1,
                }"
                @mouseover="onHoverRow(1)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.ave_date | dateFormat }}
              </td>
              <td
                colspan="5"
                style="border-left: 1px solid var(--lightbackground3)!important;"
                v-bind:class="{
                  'row-hover': hRow === 1,
                }"
                @mouseover="onHoverRow(1)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ nextMonth | dateFormat }}
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{ 'row-hover': hRow === 2 }"
                @mouseover="onHoverRow(2)"
                @mouseleave="onHoverRow(-1)"
                colspan="3"
              >
                Internal Market Price (COP/mt)
              </th>
              <td
                class="tableBig"
                v-bind:class="{
                  'row-hover': hRow === 2,
                }"
                @mouseover="onHoverRow(2)"
                @mouseleave="onHoverRow(-1)"
                colspan="6"
              >
                {{ dataVar.close | numberFormat }}
              </td>
              <td
                class="tableBig"
                v-bind:class="{
                  'row-hover': hRow === 2,
                }"
                @mouseover="onHoverRow(2)"
                @mouseleave="onHoverRow(-1)"
                colspan="5"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextColombiaPriceCOP | numberFormat }}
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 3,
                }"
                @mouseover="onHoverRow(3)"
                @mouseleave="onHoverRow(-1)"
                colspan="3"
              >
                TRM (USD/COP)
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 3,
                }"
                @mouseover="onHoverRow(3)"
                @mouseleave="onHoverRow(-1)"
                colspan="6"
              >
                {{ dataVar.trm_ave | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 3,
                }"
                @mouseover="onHoverRow(3)"
                @mouseleave="onHoverRow(-1)"
                colspan="5"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ selectedVar.cop | numberFormat }}
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 4,
                }"
                @mouseover="onHoverRow(4)"
                @mouseleave="onHoverRow(-1)"
                colspan="3"
              >
                Internal Market Price (USD/mt)
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 4,
                }"
                @mouseover="onHoverRow(4)"
                @mouseleave="onHoverRow(-1)"
                colspan="6"
              >
                {{ colombiaPriceUSD | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 4,
                }"
                @mouseover="onHoverRow(4)"
                @mouseleave="onHoverRow(-1)"
                colspan="5"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextColombiaPriceUSD | numberFormat }}
              </td>
            </tr>
            <tr>
              <th
                colspan="3"
                v-bind:class="{
                  'row-hover': hRow === 5,
                }"
                @mouseover="onHoverRow(5)"
                @mouseleave="onHoverRow(-1)"
              >
                CIF Rotterdam (USD/mt)
              </th>
              <td
                colspan="6"
                v-bind:class="{
                  'row-hover': hRow === 5,
                }"
                @mouseover="onHoverRow(5)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.rott_ave | numberFormat }}
              </td>
              <td
                colspan="5"
                v-bind:class="{
                  'row-hover': hRow === 5,
                }"
                @mouseover="onHoverRow(5)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ rott_ave | numberFormat }}
              </td>
            </tr>
            <tr>
              <th
                colspan="3"
                v-bind:class="{
                  'row-hover': hRow === 6,
                }"
                @mouseover="onHoverRow(6)"
                @mouseleave="onHoverRow(-1)"
              >
                Sale Price (USD/mt)
              </th>
              <td
                class="tableBig"
                colspan="6"
                v-bind:class="{
                  'row-hover': hRow === 6,
                }"
                @mouseover="onHoverRow(6)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ aveSalePrice | numberFormat }}
              </td>
              <td
                class="tableBig"
                colspan="5"
                v-bind:class="{
                  'row-hover': hRow === 6,
                }"
                @mouseover="onHoverRow(6)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextAveSalePrice | numberFormat }}
              </td>
            </tr>
            <tr>
              <td colspan="3" rowspan="2"></td>
              <th>Sales</th>
              <th>Price</th>
              <th colspan="2">Cessions</th>
              <th colspan="2">Compensations</th>
              <th
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                New Price
              </th>
              <th colspan="2">New Cessions</th>
              <th colspan="2">New Compensarions</th>
            </tr>
            <tr>
              <th>(mt thousands)</th>
              <th>(USD/mt)</th>
              <th><div class="text-right">(USD/mt)</div></th>
              <th><div class="text-left">(COP/mt)</div></th>
              <th><div class="text-right">(USD/mt)</div></th>
              <th><div class="text-left">(COP/mt)</div></th>

              <th
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                (USD/mt)
              </th>
              <th><div class="text-right">(USD/mt)</div></th>
              <th><div class="text-left">(COP/mt)</div></th>
              <th><div class="text-right">(USD/mt)</div></th>
              <th><div class="text-left">(COP/mt)</div></th>
            </tr>

            <tr>
              <th
                colspan="3"
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
              >
                Colombia
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_colombia }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ colombiaPriceUSD | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round((dataVar.cession * dataVar.trm_ave) / 1000))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextColombiaPriceUSD | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{
                    Math.max(nextColombiaPriceUSD - nextAveSalePrice, 0)
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (Math.max(nextColombiaPriceUSD - nextAveSalePrice, 0) *
                          selectedVar.cop) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{
                    Math.max(nextAveSalePrice - nextColombiaPriceUSD, 0)
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 7,
                }"
                @mouseover="onHoverRow(7)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (Math.max(nextAveSalePrice - nextColombiaPriceUSD, 0) *
                          selectedVar.cop) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                rowspan="4"
                colspan="2"
                v-bind:class="{
                  'row-hover': hRow >= 8 && hRow <= 11,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                G-1:<br />Venezuela
              </th>
              <th
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                North
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_north_g1 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_north_g1 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_north_g1 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_north_g1 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_north_g1 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_north_g1 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g1_n | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g1_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g1_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g1_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 8,
                }"
                @mouseover="onHoverRow(8)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g1_n | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
              >
                Center
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_center_g1 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_center_g1 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_center_g1 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_center_g1 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_center_g1 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_center_g1 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g1_c | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g1_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g1_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g1_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 9,
                }"
                @mouseover="onHoverRow(9)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g1_c | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
              >
                East
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_east_g1 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_east_g1 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_east_g1 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_east_g1 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_east_g1 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_east_g1 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g1_e | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g1_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g1_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g1_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 10,
                }"
                @mouseover="onHoverRow(10)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g1_e | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
              >
                South East
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_south_east_g1 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_south_east_g1 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_south_east_g1 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_south_east_g1 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_east_g1 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_east_g1 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g1_se | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g1_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g1_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g1_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 11,
                }"
                @mouseover="onHoverRow(11)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g1_se | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                rowspan="4"
                colspan="2"
                v-bind:class="{
                  'row-hover': hRow >= 12 && hRow <= 15,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                G-2:<br />Mexico, Peru, C. America,<br />Mercosur, USA, Bolivia
              </th>
              <th
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                North
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_north_g2 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_north_g2 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_north_g2 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_north_g2 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_north_g2 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_north_g2 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g2_n | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g2_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g2_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g2_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 12,
                }"
                @mouseover="onHoverRow(12)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g2_n | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
              >
                Center
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_center_g2 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_center_g2 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_center_g2 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_center_g2 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_center_g2 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_center_g2 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g2_c | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g2_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g2_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g2_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 13,
                }"
                @mouseover="onHoverRow(13)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g2_c | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
              >
                East
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_east_g2 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_east_g2 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_east_g2 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_east_g2 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_east_g2 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_east_g2 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g2_e | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g2_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g2_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g2_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 14,
                }"
                @mouseover="onHoverRow(14)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g2_e | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
              >
                South East
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_south_east_g2 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_south_east_g2 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_south_east_g2 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_south_east_g2 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_south_east_g2 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_south_east_g2 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g2_se | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g2_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g2_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g2_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 15,
                }"
                @mouseover="onHoverRow(15)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g2_se | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                rowspan="4"
                colspan="2"
                v-bind:class="{
                  'row-hover': hRow >= 16 && hRow <= 19,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                G-3:<br />Europe, Chile,<br />Rest of the World
              </th>
              <th
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                North
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_north_g3 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_north_g3 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_north_g3 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_north_g3 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_north_g3 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_north_g3 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g3_n | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g3_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g3_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g3_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 16,
                }"
                @mouseover="onHoverRow(16)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g3_n | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
              >
                Center
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_center_g3 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_center_g3 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_center_g3 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_center_g3 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_center_g3 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_center_g3 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g3_c | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g3_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g3_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g3_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 17,
                }"
                @mouseover="onHoverRow(17)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g3_c | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
              >
                East
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_east_g3 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_east_g3 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_east_g3 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_east_g3 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_east_g3 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_east_g3 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g3_e | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g3_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g3_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g3_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 18,
                }"
                @mouseover="onHoverRow(18)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g3_e | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
              >
                South East
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_south_east_g3 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_south_east_g3 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_south_east_g3 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_south_east_g3 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_south_east_g3 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_south_east_g3 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g3_se | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g3_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g3_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g3_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 19,
                }"
                @mouseover="onHoverRow(19)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g3_se | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                rowspan="4"
                colspan="2"
                v-bind:class="{
                  'row-hover': hRow >= 20 && hRow <= 23,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                G-4:<br />Ecuador
              </th>
              <th
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                North
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_north_g4 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_north_g4 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_north_g4 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_north_g4 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_north_g4 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_north_g4 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g4_n | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g4_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g4_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g4_n | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 20,
                }"
                @mouseover="onHoverRow(20)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g4_n | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
              >
                Center
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_center_g4 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_center_g4 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_center_g4 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_center_g4 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_center_g4 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_center_g4 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g4_c | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g4_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g4_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g4_c | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 21,
                }"
                @mouseover="onHoverRow(21)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g4_c | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
              >
                East
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_east_g4 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_east_g4 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_east_g4 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_east_g4 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_east_g4 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_east_g4 * dataVar.trm_ave) / 1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g4_e | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g4_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g4_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g4_e | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 22,
                }"
                @mouseover="onHoverRow(22)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g4_e | numberFormat }}
                </div>
              </td>
            </tr>
            <tr>
              <th
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
              >
                South East
              </th>
              <td
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.sales_south_east_g4 }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
              >
                {{ dataVar.price_south_east_g4 | numberFormat }}
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.cession_south_east_g4 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.cession_south_east_g4 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ dataVar.compensation_south_east_g4 | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{
                    (1000 *
                      Math.round(
                        (dataVar.compensation_south_east_g4 * dataVar.trm_ave) /
                          1000,
                      ))
                      | numberFormat
                  }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
                style="border-left: 1px solid var(--lightbackground3)!important;"
              >
                {{ nextPrices.g4_se | numberFormat }}
              </td>

              <td
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.cess_g4_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.cess_usd_g4_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-right color-inherit">
                  {{ nextCesComp.comp_g4_se | numberFormat }}
                </div>
              </td>
              <td
                v-bind:class="{
                  'row-hover': hRow === 23,
                }"
                @mouseover="onHoverRow(23)"
                @mouseleave="onHoverRow(-1)"
              >
                <div class="text-left color-inherit">
                  {{ nextCesComp.comp_usd_g4_se | numberFormat }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mean, timeFormat, format } from "d3";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "CPOCessionCompensation",
  components: {
    QSLoading,
  },
  props: {
    dataVar: { required: true, default: {} },
    fepHistData: { required: true, default: () => [] },
    fepTableData: { required: true, default: () => [] },
    showLoading: { required: true, type: Boolean, default: false },
  },
  data() {
    return {
      hRow: -1,
    };
  },
  computed: {
    nextCesComp() {
      let _this = this;
      let newCC = {};
      const keys = Object.keys(this.nextPrices);
      keys.forEach((key) => {
        newCC["cess_" + key] = Math.max(
          0,
          Math.round(_this.nextPrices[key] - _this.nextAveSalePrice),
        );
        newCC["cess_usd_" + key] =
          1000 *
          Math.round((newCC["cess_" + key] * _this.selectedVar.cop) / 1000);
        newCC["comp_" + key] = Math.max(
          0,
          Math.round(_this.nextAveSalePrice - _this.nextPrices[key]),
        );
        newCC["comp_usd_" + key] =
          1000 *
          Math.round((newCC["comp_" + key] * _this.selectedVar.cop) / 1000);
      });
      return newCC;
    },
    nextPrices() {
      return {
        g1_n:
          this.rott_ave + (this.dataVar.price_north_g1 - this.dataVar.rott_ave),
        g1_c:
          this.rott_ave +
          (this.dataVar.price_center_g1 - this.dataVar.rott_ave),
        g1_e:
          this.rott_ave + (this.dataVar.price_east_g1 - this.dataVar.rott_ave),
        g1_se:
          this.rott_ave +
          (this.dataVar.price_south_east_g1 - this.dataVar.rott_ave),
        g2_n:
          this.rott_ave + (this.dataVar.price_north_g2 - this.dataVar.rott_ave),
        g2_c:
          this.rott_ave +
          (this.dataVar.price_center_g2 - this.dataVar.rott_ave),
        g2_e:
          this.rott_ave + (this.dataVar.price_east_g2 - this.dataVar.rott_ave),
        g2_se:
          this.rott_ave +
          (this.dataVar.price_south_east_g2 - this.dataVar.rott_ave),
        g3_n:
          this.rott_ave + (this.dataVar.price_north_g3 - this.dataVar.rott_ave),
        g3_c:
          this.rott_ave +
          (this.dataVar.price_center_g3 - this.dataVar.rott_ave),
        g3_e:
          this.rott_ave + (this.dataVar.price_east_g3 - this.dataVar.rott_ave),
        g3_se:
          this.rott_ave +
          (this.dataVar.price_south_east_g3 - this.dataVar.rott_ave),
        g4_n:
          this.rott_ave + (this.dataVar.price_north_g4 - this.dataVar.rott_ave),
        g4_c:
          this.rott_ave +
          (this.dataVar.price_center_g4 - this.dataVar.rott_ave),
        g4_e:
          this.rott_ave + (this.dataVar.price_east_g4 - this.dataVar.rott_ave),
        g4_se:
          this.rott_ave +
          (this.dataVar.price_south_east_g4 - this.dataVar.rott_ave),
      };
    },
    rott_ave() {
      let selData;
      if (+this.fepTableData[0].date === +this.dataVar.date) {
        selData = this.fepTableData[0];
      } else {
        selData = this.fepTableData[1];
      }
      return mean(this.fepHistData, function(d) {
        return Number.isFinite(d.rott) && d.rott != null
          ? d.rott
          : selData.rott;
      });
    },
    selectedVar() {
      return +this.fepTableData[0].date === +this.dataVar.date
        ? this.fepTableData[0]
        : this.fepTableData[1];
    },
    nextMonth() {
      let dat = new Date(this.dataVar.ave_date);
      dat.setHours(0, 0, 0, 0);
      dat.setMonth(dat.getMonth() + 1);
      dat.setDate(1);
      return dat;
    },
    colombiaPriceUSD() {
      return this.dataVar.price_g2;
      //   Math.min(
      //   (this.dataVar.bmd + this.dataVar.freight_bmd) *
      //     (1 + this.dataVar.tariff_bmd),
      //   0.65 *
      //     Math.min(
      //       (this.dataVar.arg + this.dataVar.freight_arg) *
      //         (1 + this.dataVar.tariff_arg),
      //       (this.dataVar.usa + this.dataVar.freight_usa) *
      //         (1 + this.dataVar.tariff_usa)
      //     ) +
      //     0.35 *
      //       Math.min(
      //         (this.dataVar.tallow + this.dataVar.freight_tallow) *
      //           (1 + this.dataVar.tariff_tallow),
      //         (this.dataVar.stearin + this.dataVar.freight_stearin) *
      //           (1 + this.dataVar.tariff_stearin)
      //       )
      // );
    },
    nextColombiaPriceUSD() {
      return (
        (this.selectedVar.bmd_usd + this.dataVar.freight_bmd) *
        (1 + this.dataVar.tariff_bmd)
      );
    },
    nextColombiaPriceCOP() {
      return (
        (this.selectedVar.bmd_usd + this.dataVar.freight_bmd) *
        (1 + this.dataVar.tariff_bmd) *
        this.selectedVar.cop
      );
    },
    aveSalePrice() {
      return this.dataVar.price_g3;
      //   (
      //   this.dataVar.adjustment_factor +
      //   (this.colombiaPriceUSD * this.dataVar.sales_colombia +
      //     this.dataVar.price_north_g1 * this.dataVar.sales_north_g1 +
      //     this.dataVar.price_center_g1 * this.dataVar.sales_center_g1 +
      //     this.dataVar.price_east_g1 * this.dataVar.sales_east_g1 +
      //     this.dataVar.price_south_east_g1 * this.dataVar.sales_south_east_g1 +
      //     this.dataVar.price_north_g2 * this.dataVar.sales_north_g2 +
      //     this.dataVar.price_center_g2 * this.dataVar.sales_center_g2 +
      //     this.dataVar.price_east_g2 * this.dataVar.sales_east_g2 +
      //     this.dataVar.price_south_east_g2 * this.dataVar.sales_south_east_g2 +
      //     this.dataVar.price_north_g3 * this.dataVar.sales_north_g3 +
      //     this.dataVar.price_center_g3 * this.dataVar.sales_center_g3 +
      //     this.dataVar.price_east_g3 * this.dataVar.sales_east_g3 +
      //     this.dataVar.price_south_east_g3 * this.dataVar.sales_south_east_g3 +
      //     this.dataVar.price_north_g4 * this.dataVar.sales_north_g4 +
      //     this.dataVar.price_center_g4 * this.dataVar.sales_center_g4 +
      //     this.dataVar.price_east_g4 * this.dataVar.sales_east_g4 +
      //     this.dataVar.price_south_east_g4 * this.dataVar.sales_south_east_g4) /
      //     (this.dataVar.sales_colombia +
      //       this.dataVar.sales_north_g1 +
      //       this.dataVar.sales_center_g1 +
      //       this.dataVar.sales_east_g1 +
      //       this.dataVar.sales_south_east_g1 +
      //       this.dataVar.sales_north_g2 +
      //       this.dataVar.sales_center_g2 +
      //       this.dataVar.sales_east_g2 +
      //       this.dataVar.sales_south_east_g2 +
      //       this.dataVar.sales_north_g3 +
      //       this.dataVar.sales_center_g3 +
      //       this.dataVar.sales_east_g3 +
      //       this.dataVar.sales_south_east_g3 +
      //       this.dataVar.sales_north_g4 +
      //       this.dataVar.sales_center_g4 +
      //       this.dataVar.sales_east_g4 +
      //       this.dataVar.sales_south_east_g4)
      // );
    },
    nextAveSalePrice() {
      return Math.round(
        this.dataVar.adjustment_factor +
          (this.nextColombiaPriceUSD * this.dataVar.sales_colombia +
            this.nextPrices.g1_n * this.dataVar.sales_north_g1 +
            this.nextPrices.g1_c * this.dataVar.sales_center_g1 +
            this.nextPrices.g1_e * this.dataVar.sales_east_g1 +
            this.nextPrices.g1_se * this.dataVar.sales_south_east_g1 +
            this.nextPrices.g2_n * this.dataVar.sales_north_g2 +
            this.nextPrices.g2_c * this.dataVar.sales_center_g2 +
            this.nextPrices.g2_e * this.dataVar.sales_east_g2 +
            this.nextPrices.g2_se * this.dataVar.sales_south_east_g2 +
            this.nextPrices.g3_n * this.dataVar.sales_north_g3 +
            this.nextPrices.g3_c * this.dataVar.sales_center_g3 +
            this.nextPrices.g3_e * this.dataVar.sales_east_g3 +
            this.nextPrices.g3_se * this.dataVar.sales_south_east_g3 +
            this.nextPrices.g4_n * this.dataVar.sales_north_g4 +
            this.nextPrices.g4_c * this.dataVar.sales_center_g4 +
            this.nextPrices.g4_e * this.dataVar.sales_east_g4 +
            this.nextPrices.g4_se * this.dataVar.sales_south_east_g4) /
            (this.dataVar.sales_colombia +
              this.dataVar.sales_north_g1 +
              this.dataVar.sales_center_g1 +
              this.dataVar.sales_east_g1 +
              this.dataVar.sales_south_east_g1 +
              this.dataVar.sales_north_g2 +
              this.dataVar.sales_center_g2 +
              this.dataVar.sales_east_g2 +
              this.dataVar.sales_south_east_g2 +
              this.dataVar.sales_north_g3 +
              this.dataVar.sales_center_g3 +
              this.dataVar.sales_east_g3 +
              this.dataVar.sales_south_east_g3 +
              this.dataVar.sales_north_g4 +
              this.dataVar.sales_center_g4 +
              this.dataVar.sales_east_g4 +
              this.dataVar.sales_south_east_g4),
      );
    },
  },
  methods: {
    onHoverRow(idx) {
      this.hRow = idx;
    },
  },
  filters: {
    dateFormat: function(val) {
      return val === null ||
        val === "" ||
        val === 0 ||
        +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%B %Y")(val);
    },
    numberFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.0f")(val);
    },
  },
};
</script>

<style scoped>
.tableBig {
  background-color: var(--expo-alpha-3);
  border-bottom: 1px solid var(--symmetry-h);
  font-size: 1rem;
  color: var(--textactive);
}
</style>
